import LoginButton from "@/components/LoginButton";

export default function FirstPage(props: any) {
  return (
    <div>
      First Page
    </div>
  )
}
